import {
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  FilterSettingsModel,
  GridComponent,
  Page,
  Inject,
  PageSettingsModel,
  Toolbar,
  EditSettingsModel,
  Filter,
  ColumnMenu,
  Resize,
  ColumnChooser,
  ExcelExport,
  Group,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { AnimationSettingsModel } from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai';
import { BiX } from 'react-icons/bi';
import { all_information, loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import {
  AddShiftWorkbench,
  EditShiftWorkbench,
  getShiftWorkbench,
  DeleteShiftWorkbench,
} from '../../services/ShiftWorkbench/ShiftWorkbenchService';
import '../ShiftWorkbench/swb.css';
import TabWorkbench from './TabBottom/TabWorkbench';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ThemeContext } from '../../context/theme.context';
import { BsCheck2 } from 'react-icons/bs';
import { getShiftWorkbenchSettings } from '../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import { getElementAlias } from '../../services/Settings/ElementAlias';
import { getTeamAssigments, getTeams } from '../../services/tradeperson/team';
import { getAssignments } from '../../services/assignments/assignmentService';
import { GetRosters } from '../../services/Settings/Roster';
interface IState {
  main_grid_data_source: Array<any>;
  selectedChipDayText: string;
  selectedChipShiftText: string;
  WorkbenchData: Array<any>;
  WorkbenchLeaveData: Array<any>;
  WorkbenchIncidentsData: Array<any>;
  WorkbenchHseData: Array<any>;
  WorkbenchHazardData: Array<any>;
  WorkbenchEquipmentData: Array<any>;
  SupervisorData: Array<any>;
  SiteData: Array<any>;
  LocationData: Array<any>;
  ElementAliasData: Array<any>;
  TeamsData: Array<any>;
  TeamAssignmentData: Array<any>;
  ShiftElementData: Array<any>;
  hideDialogLeave: boolean;
  aliasValue: any;
  showSection1: boolean;
  showSection2: boolean;
  checkedAllAssignment: boolean;
  WorkbencStatusData: Array<any>;
  WorkbencIncidentsDetailsData: Array<any>;
  WorkbencHseDetailsData: Array<any>;
  EquipmentDTRData: Array<any>;
}
interface IProps {
  workbench_id: number;
  trans_date: Date;
  workbench_data: any;
}
class ShiftWorkbench extends Component<IProps, IState> {
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: 'Top',
  };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private animationSettings: AnimationSettingsModel;
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  private main_grid_shift: GridComponent;
  private gridWorkbenchIncidentsObj: any;
  private gridWorkbenchHseObj: any;
  private gridWorkbenchEquipmentDowntimeObj: any;
  private gridWorkbenchLeaveAbsenteesObj: any;
  private gridWorkenchHazarActionsObj: any;
  private gridWorkbenchNotesEventsObj: any;
  private ddTeams: any;
  private chipWorkbenchDay: ChipListComponent = new ChipListComponent({});
  private chipsWorkbenchShift: any;
  private textareaObjIssue: any;
  private changeFlexDirection: any = 'row';
  private ddSuppervisor: DropDownListComponent;
  private ddSites: DropDownListComponent = new DropDownListComponent({});
  private ddLocation: DropDownListComponent = new DropDownListComponent({});
  private ddShift: DropDownListComponent = new DropDownListComponent({});
  private ddShiftElment: DropDownListComponent = new DropDownListComponent({});
  private ddObjectEqupmentDTReasons: any;
  private ddHseStatus: any;
  private ddWorkbenchStatusData: any;
  private ddIncidentsType: any;
  private ddHseDetails: any;
  private ddOperatorRaisedBy: any;
  private ddOperatorActionBy: any;
  private ddOperatorLeave: any;

  public formatOptions = 'dd/MM/yyyy';
  private weekday = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  private created_date = this.props.trans_date;
  private issue = '';
  private actions = '';
  private cause = '';
  private isEdit = false;
  private ddOperator: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private fieldSupervisor: object = {
    text: 'supervisor_name',
    value: 'id',
  };
  private fieldSites: object = {
    text: 'site_name',
    value: 'id',
  };
  private fieldLocation: object = {
    text: 'department_name',
    value: 'id',
  };
  private fieldAlias: object = {
    text: 'element_alias_name',
    value: 'element_alias_id',
  };
  private fieldTeams: object = {
    text: 'team_code',
    value: 'team_id',
  };
  private fieldOperator: object = {
    text: 'alias_name',
    value: 'assignment_id',
  };
  private fieldWorkbenchStatus: object = {
    text: 'status_alias',
    value: 'id',
  };
  private fieldWorkbenchIncidentsType: object = {
    text: 'incident',
    value: 'id',
  };
  private fieldWorkbenchHseDetails: object = {
    text: 'hse',
    value: 'id',
  };
  private currentComplete: boolean = false;
  constructor(prop: IProps) {
    super(prop);
    this.main_grid_shift = new GridComponent(prop);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.state = {
      main_grid_data_source: [],
      WorkbenchData: [],
      WorkbenchLeaveData: [],
      WorkbenchIncidentsData: [],
      WorkbenchHazardData: [],
      WorkbenchHseData: [],
      WorkbenchEquipmentData: [],
      SupervisorData: [],
      SiteData: [],
      LocationData: [],
      ElementAliasData: [],
      TeamsData: [],
      TeamAssignmentData: [],
      ShiftElementData: [],
      WorkbencStatusData: [],
      WorkbencIncidentsDetailsData: [],
      WorkbencHseDetailsData: [],
      selectedChipDayText: '',
      selectedChipShiftText: '',
      hideDialogLeave: false,
      aliasValue: -1,
      showSection1: false,
      showSection2: true,
      checkedAllAssignment: true,
      EquipmentDTRData: [],
    };
    this.ddObjectEqupmentDTReasons = new DropDownListComponent(prop);
    this.ddSuppervisor = new DropDownListComponent({});
  }
  async getWorkbenchHseDetails() {
    getShiftWorkbenchSettings('hseq').then((res) => {
      this.setState({ WorkbencHseDetailsData: res.data });
    });
  }
  async getWorkbenchIncidentsDetails() {
    getShiftWorkbenchSettings('incident').then((res) => {
      this.setState({ WorkbencIncidentsDetailsData: res.data });
    });
  }
  async getWorkbenchStatus() {
    await getShiftWorkbenchSettings('workbenchstatus').then((res) => {
      this.setState({ WorkbencStatusData: res.data });
    });
  }
  getTeamAssignment(teamID: number) {
    getTeamAssigments(teamID).then((res) => {
      this.setState({ TeamAssignmentData: res.data });
    });
  }
  getAllAssignment() {
    getAssignments().then((res) => {
      this.setState({ TeamAssignmentData: res.data });
    });
  }
  async getWorkbench(unit_code: string) {
    await getShiftWorkbench(unit_code).then((res) => {
      this.setState({ WorkbenchData: res.data });
    });
  }
  async getShiftElments() {
    await GetRosters().then((res) => {
      let filterData = res.data.filter(
        (x: any) => x.rosterType === 'Exception'
      );
      this.setState({ ShiftElementData: filterData });
    });
  }
  async getWorkbenchLeave(query: string) {
    await getShiftWorkbench(query).then((res) => {
      this.setState({ WorkbenchLeaveData: res.data });
    });
  }
  async getWorkbenchIncidents(query: string) {
    await getShiftWorkbench(query).then((res) => {
      this.setState({ WorkbenchIncidentsData: res.data });
    });
  }
  async getWorkbenchHse(query: string) {
    await getShiftWorkbench(query).then((res) => {
      this.setState({ WorkbenchHseData: res.data });
    });
  }
  async getWorkbenchEquipment(query: string) {
    await getShiftWorkbench(query).then((res) => {
      this.setState({ WorkbenchEquipmentData: res.data });
    });
  }
  async getWorkbenchHazard(query: string) {
    await getShiftWorkbench(query).then((res) => {
      this.setState({ WorkbenchHazardData: res.data });
    });
  }
  async getWorkbenchSupervisor() {
    await getShiftWorkbenchSettings('supervisor').then((res) => {
      this.setState({ SupervisorData: res.data });
    });
  }
  getWorkbenchEquipmentDTR() {
    getShiftWorkbenchSettings('edreason').then((res) => {
      this.setState({ EquipmentDTRData: res.data });
    });
  }
  async getWorkbenchSites() {
    await getShiftWorkbenchSettings('sites').then((res) => {
      this.setState({ SiteData: res.data });
    });
  }
  async getWorkbenchLocation() {
    await getShiftWorkbenchSettings('department').then((res) => {
      this.setState({ LocationData: res.data });
    });
  }
  async getTeams() {
    await getTeams().then((res) => {
      this.setState({ TeamsData: res.data });
    });
  }
  async getWorkbenchElementAlias() {
    await getElementAlias(true).then((res) => {
      this.setState({ ElementAliasData: res.data });
    });
  }
  async componentDidMount() {
    loadingShow(true);
    setTimeout(() => {
      loadingShow(false);
    }, 10000);
    await this.getWorkbenchSites();
    await this.getWorkbenchLocation();
    await this.getWorkbenchSupervisor();
    this.getWorkbenchEquipmentDTR();
    this.getWorkbenchElementAlias();
    await this.getTeams();
    await this.getShiftElments();
    await this.getWorkbenchStatus();
    this.getWorkbenchHseDetails();
    this.getWorkbenchIncidentsDetails();
    let theDate = new Date(this.created_date);
    this.chipWorkbenchDay.selectedChips = theDate.getDay() - 1;
    this.setState({
      selectedChipDayText: this.weekday[theDate.getDay() - 1],
    });
    // $('.disabledTeam').addClass('disabledDiv');
    this.loadForInput(this.props.workbench_id);

    await this.getWorkbenchIncidents(`incidents$${this.props.workbench_id}`);
    await this.getWorkbenchLeave(`leave$${this.props.workbench_id}`);
    await this.getWorkbenchHse(`hse$${this.props.workbench_id}`);
    await this.getWorkbenchHazard(`hazard$${this.props.workbench_id}`);
    await this.getWorkbenchEquipment(`eq$${this.props.workbench_id}`);
    $('.disabledTeam').addClass('disabledDiv');
    if (this.props.workbench_id > 0) {
      $('workbench-flex').addClass('auto-width');
    } else {
      $('workbench-flex').removeClass('auto-width');
    }
    loadingShow(false);
  }
  private onCreateIssue(): void {
    this.textareaObjIssue.addAttributes({ rows: 5 });
    this.textareaObjIssue.respectiveElement.style.height = '28vh';
    this.textareaObjIssue.respectiveElement.style.width = '20vw';
    this.textareaObjIssue.respectiveElement.style.maxHeight = '28vh';
  }
  selectedChipDayt(args: any) {
    var date = new Date(this.created_date);
    let index =
      this.weekday.findIndex((x: any) => x === args.target.textContent) + 1;
    let day = 0;
    if (date.getDay() > index) {
      day = date.getDay() - index;
      date.setDate(date.getDate() - day);
    } else if (date.getDay() < index) {
      day = index - date.getDay();
      date.setDate(date.getDate() + day);
    } else {
      date.setDate(date.getDate() + day);
    }
    this.created_date = new Date(date);

    this.setState({ selectedChipDayText: args.target.textContent });
  }
  OnChangeTransactionDate(args: any) {
    var transactionDate = new Date(args.value);
    this.created_date = transactionDate;
    this.chipWorkbenchDay.selectedChips =
      transactionDate.getDay() - 1 === -1 ? 6 : transactionDate.getDay() - 1;
  }
  async loadForInput(workbench_id: number) {
    let date = new Date(this.props.trans_date);
    this.created_date = date;
    let theData = this.props.workbench_data;
    if (this.chipWorkbenchDay)
      this.chipWorkbenchDay.selectedChips =
        date.getDay() - 1 === -1 ? 6 : date.getDay() - 1;
    this.setState({ selectedChipDayText: this.weekday[date.getDay() - 1] });
    this.getAllAssignment();
    this.ddSites.value = theData.site_id;
    this.ddLocation.value = theData.location_id;
    this.ddShift.value = theData.element_alias_id;
    this.ddTeams.value = theData.team_id;
    this.ddWorkbenchStatusData.value = theData.workbench_status_id;
    this.ddSuppervisor.value = theData.supervisor_id;
    this.issue = theData.issue;
    this.actions = theData.actions;
    this.cause = theData.cause;
    this.isEdit = true;
    $('.disabledWorkbencDate').addClass('disabledDiv');
  }
  clearForInput() {
    this.isEdit = false;
    this.issue = '';
    this.actions = '';
    this.cause = '';
    // this.props.workbench_id = -1;
    this.ddSuppervisor.value = 0;
    this.ddSites.value = 0;
    this.ddLocation.value = 0;
    this.ddShift.value = 0;
    this.ddTeams.value = null;
    this.ddWorkbenchStatusData.value = null;

    this.created_date = new Date();
    this.chipWorkbenchDay.selectedChips = this.created_date.getDay() - 1;
    this.setState({
      selectedChipDayText: this.weekday[this.created_date.getDay() - 1],
      checkedAllAssignment: false,
    });

    // $('workbench-flex').removeClass('auto-width');
  }
  savePoint() {
    let supervisor = this.ddSuppervisor.value;
    let site = this.ddSites.value;
    let location = this.ddLocation.value;
    let elementAlias = this.ddShift.value;
    let team = this.ddTeams.value;
    let workbench_status = this.ddWorkbenchStatusData.value;

    if (team === undefined || team === null) {
      Message.error('Can not be empty Teams');
      return false;
    }
    if (supervisor === undefined || supervisor === null) {
      Message.error('Can not be empty Supervisor');
      return false;
    }
    if (site === undefined || site === null) {
      Message.error('Can not be empty Site');
      return false;
    }
    if (location === undefined || location === null) {
      Message.error('Can not be empty Location');
      return false;
    }
    if (elementAlias === undefined || elementAlias === null) {
      Message.error('Can not be empty Shift');
      return false;
    }
    if (workbench_status === undefined || workbench_status === null) {
      Message.error('Can not be empty Status');
      return false;
    }
    loadingShow(true);
    var date =
      '/Date(' + new Date(this.created_date).getTime() + '-0500' + ')/';
    const obj = {
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      supervisor_id: supervisor,
      date: date,
      day: new Date(this.created_date).getDay(),
      team_id: team,
      element_alias_id: elementAlias,
      site_id: site,
      location_id: location,
      workbench_status_id: workbench_status,
      user_id: all_information.user_id,
      issue: this.issue,
      actions: '',
      cause: '',
      id: this.props.workbench_id,
    };
    let newArray = new Array();
    newArray.push(obj);
    let objeEdit = {
      BulkWorkbenchDtos: newArray,
    };

    if (!this.isEdit) {
      AddShiftWorkbench(obj)
        .then((res: any) => {
          Message.success('Success');
          loadingShow(false);
          this.findLastIndexWorkbench();
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    } else {
      EditShiftWorkbench(objeEdit)
        .then((res: any) => {
          Message.success('Success');
          loadingShow(false);
          this.getWorkbench('workbench');
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    }
  }
  findLastIndexWorkbench = async () => {
    this.loadForInput(this.props.workbench_id);
  };
  actionBeginLeave(args: any) {
    if (args.action === 'add') {
      this.savePointAddLeave(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditLeave(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteLeave(args.data);
    }
  }
  actionBeginIncidents(args: any) {
    if (args.action === 'add') {
      this.savePointAddIncidents(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditIncidents(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteIncidents(args.data);
    }
  }
  actionBeginHse(args: any) {
    if (args.action === 'add') {
      this.savePointAddHse(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditHse(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteHse(args.data);
    }
  }
  actionBeginHazard(args: any) {
    if (args.action === 'add') {
      this.savePointAddHazard(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditHazard(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteHazard(args.data);
    }
  }
  actionBeginEquipment(args: any) {
    if (args.action === 'add') {
      this.savePointAddEquipment(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditEquipment(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteEquipment(args.data);
    }
  }
  savePointAddLeave(obje: any) {
    if (this.props.workbench_id == -1) {
      Message.error('Please create a workbench first!');
      return false;
    }
    let leave_type = this.ddShiftElment.text;
    let leave_name = this.ddOperatorLeave.text;

    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      name: leave_name,
      leave_type: leave_type,
      date: this.created_date,
      created_by: all_information.user_id,
      unit: 'leave',
    });
    AddShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchLeave(`leave$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditLeave(obje: any) {
    let leave_type = this.ddShiftElment?.text;
    let leave_name = this.ddOperatorLeave?.text;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      name: leave_name,
      leave_type: leave_type,
      date: this.created_date,
      created_by: all_information.user_id,
      id: obje.id,
      unit: 'leave',
    });
    EditShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchLeave(`leave$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteLeave(obje: any) {
    if (!obje[0].id) {
      Message.error('Something went wrong');
      return;
    }
    const obj = {
      id: obje[0].id,
    };
    DeleteShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchLeave(`leave$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointAddIncidents(obje: any) {
    if (this.props.workbench_id == -1) {
      Message.error('Please create a workbench first!');
      return false;
    }
    let incidents = this.ddOperator.text;
    let incidentsType = this.ddIncidentsType.text;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      incidents: incidents,
      incidents_type: incidentsType,
      date: this.created_date,
      incidents_date: obje.incidents_date,
      days_into_roster: obje.days_into_roster,
      comments: obje.comments,
      created_by: all_information.user_id,
      unit: 'incidents',
    });
    AddShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);

        this.getWorkbenchIncidents(`incidents$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditIncidents(obje: any) {
    let incidents = this.ddOperator.text;
    let incidentsType = this.ddIncidentsType.text;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: obje.workbench_id,
      incidents: incidents,
      incidents_type: incidentsType,
      date: this.created_date,
      incidents_date: obje.incidents_date,
      days_into_roster: obje.days_into_roster,
      comments: obje.comments,
      created_by: all_information.user_id,
      id: obje.id,
      unit: 'incidents',
    });
    EditShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);

        this.getWorkbenchIncidents(`incidents$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteIncidents(obje: any) {
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchIncidents(`incidents$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointAddHse(obje: any) {
    if (this.props.workbench_id == -1) {
      Message.error('Please create a workbench first!');
      return false;
    }
    let status = this.ddHseStatus.checked;
    let hse_code = this.ddHseDetails;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      description: obje.description,
      hse_code: hse_code.text,
      hse_code_id: hse_code.value,
      isChecked: status,
      date: this.created_date,
      created_by: all_information.user_id,
      unit: 'hse',
    });
    AddShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchHse(`hse$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditHse(obje: any) {
    let status = this.ddHseStatus.checked;
    let hse_code = this.ddHseDetails;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      description: obje.description,
      hse_code: hse_code.text,
      hse_code_id: hse_code.value,
      isChecked: status,
      date: this.created_date,
      created_by: all_information.user_id,
      id: obje.id,
      unit: 'hse',
    });
    EditShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchHse(`hse$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteHse(obje: any) {
    if (!obje[0].id) {
      Message.error('Something went wrong');
      return;
    }
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchHse(`hse$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointAddHazard(obje: any) {
    if (this.props.workbench_id == -1) {
      Message.error('Please create a workbench first!');
      return false;
    }
    let action_by = this.ddOperatorActionBy.text;
    let raised_by = this.ddOperatorRaisedBy.text;

    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      actions: obje.actions,
      hazard: obje.hazard,
      raised_by: raised_by,
      date: this.created_date,
      created_by: all_information.user_id,
      action_by: action_by,
      action_date: obje.action_date,
      completed: this.currentComplete,
      unit: 'hazard',
    });
    AddShiftWorkbench(obj)
      .then((res) => {
        loadingShow(false);
        this.getWorkbenchHazard(`hazard$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  componentWillUnmount() {
    //('Destroy edildi');
  }
  savePointEditHazard(obje: any) {
    if (this.props.workbench_id == -1) {
      Message.error('Please create a workbench first!');
      return false;
    }
    let action_by = this.ddOperatorActionBy.text;
    let raised_by = this.ddOperatorRaisedBy.text;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      actions: obje.actions,
      hazard: obje.hazard,
      raised_by: raised_by,
      date: this.created_date,
      created_by: all_information.user_id,
      action_by: action_by,
      action_date: obje.action_date,
      completed: this.currentComplete,
      id: obje.id,
      unit: 'hazard',
    });
    EditShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchHazard(`hazard$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteHazard(obje: any) {
    if (!obje[0].id) {
      Message.error('Something went wrong');
      return;
    }
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchHazard(`hazard$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointAddEquipment(obje: any) {
    if (this.props.workbench_id == -1) {
      Message.error('Please create a workbench first!');
      return false;
    }
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      end_time: obje.end_time,
      start_time: obje.start_time,
      duration: obje.duration,
      assets_description: obje.assets_description,
      machine_impacted: obje.machine_impacted,
      isChecked: true,
      date: this.created_date,
      user_id: all_information.user_id,
      reason_for_delay: obje.reason_for_delay,
      reason_code: this.ddObjectEqupmentDTReasons.text,
      reason_code_id: this.ddObjectEqupmentDTReasons.value,
      unit: 'eq',
    });
    AddShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchEquipment(`eq$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditEquipment(obje: any) {
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.props.workbench_id,
      end_time: obje.end_time,
      start_time: obje.start_time,
      duration: obje.duration,
      assets_description: obje.assets_description,
      machine_impacted: obje.machine_impacted,
      isChecked: true,
      date: this.created_date,
      user_id: all_information.user_id,
      reason_for_delay: obje.reason_for_delay,
      id: obje.id,
      reason_code: this.ddObjectEqupmentDTReasons.text,
      reason_code_id: this.ddObjectEqupmentDTReasons.value,
      unit: 'eq',
    });

    EditShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchEquipment(`eq$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteEquipment(obje: any) {
    if (!obje[0].id) {
      Message.error('Something went wrong');
      return;
    }
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchEquipment(`eq$${this.props.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  private toolbarClickIncidents(args: any) {
    if (args.item.text === 'Add') {
      if (this.props.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchIncidentsObj.refresh();
      }
    }
    if (args.item.text === 'Refresh') {
      this.getWorkbenchIncidents(`incidents$${this.props.workbench_id}`);
    }

    if (
      this.gridWorkbenchIncidentsObj &&
      args.item.id === 'gridWorkbenchIncidents_excelexport'
    ) {
      this.gridWorkbenchIncidentsObj.excelExport();
    }
  }
  private toolbarClickEquipmentDowntime(args: any) {
    if (args.item.text === 'Add') {
      if (this.props.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchEquipmentDowntimeObj.refresh();
      }
    }
    if (args.item.text === 'Refresh') {
      this.getWorkbenchEquipment(`eq$${this.props.workbench_id}`);
    }
    if (
      this.gridWorkbenchEquipmentDowntimeObj &&
      args.item.id === 'gridWorkbenchEquipmentDowntime_excelexport'
    ) {
      this.gridWorkbenchEquipmentDowntimeObj.excelExport();
    }
  }
  private toolbarClickHse(args: any) {
    if (args.item.text === 'Add') {
      if (this.props.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchHseObj.refresh();
      }
    }
    if (args.item.text === 'Refresh') {
      this.getWorkbenchHse(`hse$${this.props.workbench_id}`);
    }
    if (
      this.gridWorkbenchHseObj &&
      args.item.id === 'gridWorkenchHse_excelexport'
    ) {
      this.gridWorkbenchHseObj.excelExport();
    }
  }
  private toolbarClickLeave(args: any) {
    if (args.item.text === 'Add') {
      if (this.props.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkbenchLeaveAbsenteesObj.refresh();
      }
    }
    if (args.item.text === 'Refresh') {
      this.getWorkbenchHazard(`leave$${this.props.workbench_id}`);
    }
    if (
      this.gridWorkbenchLeaveAbsenteesObj &&
      args.item.id === 'gridWorkbenchLeaveAbsentees_excelexport'
    ) {
      this.gridWorkbenchLeaveAbsenteesObj.excelExport();
    }
  }
  private toolbarClickHazard(args: any) {
    if (args.item.text === 'Add') {
      if (this.props.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWorkenchHazarActionsObj.refresh();
      }
    }
    if (args.item.text === 'Refresh') {
      this.getWorkbenchHazard(`hazard$${this.props.workbench_id}`);
    }
    if (
      this.gridWorkenchHazarActionsObj &&
      args.item.id === 'gridWorkenchHazarActions_excelexport'
    ) {
      this.gridWorkenchHazarActionsObj.excelExport();
    }
  }
  private isCompleteTemplateEditin(args: any) {
    return (
      <SwitchComponent
        checked={args.completed}
        onChange={this.onChangeSwitchComplete.bind(this, args)}
      />
    );
  }
  private onChangeSwitchComplete(args: any, argsCol: any) {
    // this.isComplete = argsCol.target.checked ? 1 : 0;
    this.currentComplete = argsCol.target.checked;
    // this.SaveListOrderEdit(obj);
  }
  private isCompleteTemplate(args: any) {
    let isComplete = args.completed;
    return (
      <div>
        {isComplete ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private onChangeTeams(args: any) {
    if (!this.state.checkedAllAssignment) {
      this.getTeamAssignment(args.value);
    }
  }
  private OperatorTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Name'
        text={args.incidents}
        value={args.incidents}
        dataSource={this.state.TeamAssignmentData}
        ref={(scope) => (this.ddOperator = scope)}
        fields={this.fieldOperator}
      />
    );
  }
  private OperatorLeaveTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Name'
        text={args.name}
        value={args.name}
        dataSource={this.state.TeamAssignmentData}
        ref={(scope) => (this.ddOperatorLeave = scope)}
        fields={this.fieldOperator}
      />
    );
  }
  private OperatorActionByTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Action By'
        text={args.action_by}
        value={args.action_by}
        dataSource={this.state.TeamAssignmentData}
        ref={(scope) => (this.ddOperatorActionBy = scope)}
        fields={this.fieldOperator}
      />
    );
  }
  private OperatorRaisedByTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Raised By'
        text={args.raised_by}
        value={args.raised_by}
        dataSource={this.state.TeamAssignmentData}
        ref={(scope) => (this.ddOperatorRaisedBy = scope)}
        fields={this.fieldOperator}
      />
    );
  }
  private IncidentsTypeTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Incidents Type'
        text={args.incidents_type}
        value={args.incidents_type}
        dataSource={this.state.WorkbencIncidentsDetailsData}
        ref={(scope) => (this.ddIncidentsType = scope)}
        fields={this.fieldWorkbenchIncidentsType}
      />
    );
  }
  private HseDetailsTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Code'
        text={args.hse_code}
        value={args.hse_code_id}
        dataSource={this.state.WorkbencHseDetailsData}
        ref={(scope) => (this.ddHseDetails = scope)}
        fields={this.fieldWorkbenchHseDetails}
      />
    );
  }
  private EquipmentDowntimeReasonTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        dataSource={this.state.EquipmentDTRData}
        placeholder='EDT Reason'
        fields={{ text: 'reason', value: 'id' }}
        value={args.reason_code_id}
        text={args.reason_code}
        ref={(scope) => (this.ddObjectEqupmentDTReasons = scope)}
      />
    );
  }
  private LeaveAbsentesTypeTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        dataSource={this.state.ShiftElementData}
        placeholder='Leave Type'
        fields={{ text: 'rosterCode', value: 'rosterId' }}
        value={args.leave_type}
        text={args.leave_type}
        ref={(scope: DropDownListComponent) => (this.ddShiftElment = scope)}
        itemTemplate={
          (this.itemTemplateShiftColor = this.itemTemplateShiftColor.bind(this))
        }
      />
    );
  }
  private itemTemplateShiftColor(data: any): JSX.Element {
    return (
      <span>
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.rostercolor }}
        ></span>
        <span>{data.rosterCode + ' - ' + data.description}</span>
      </span>
    );
  }
  private itemTemplateWorkbenchStatusColor(data: any): JSX.Element {
    return (
      <span
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          paddingLeft: '5px',
        }}
      >
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.status_color }}
        ></span>
        <span>{data.status_alias}</span>
      </span>
    );
  }
  private isHseStatustemplate(args: any) {
    let isChecked = args.isChecked;
    return (
      <div>
        {isChecked ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private isHseStatustemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.isChecked}
        ref={(scope) => (this.ddHseStatus = scope)}
      />
    );
  }
  private onChangeShowAllAssignment = (args: any) => {
    let isAssignment = true;
    this.setState({ checkedAllAssignment: args.target.checked });
    if (args.target.checked) {
      $('.disabledTeam').addClass('disabledDiv');
      this.getAllAssignment();
    } else {
      isAssignment = false;
      $('.disabledTeam').removeClass('disabledDiv');
      this.getTeamAssignment(this.props.workbench_data.team_id);
    }
  };
  statusValueTemplate(args: any) {
    return <span>{args.status_color}</span>;
  }
  render() {
    return (
      <div className='main-wrap'>
        <div className='workbench-top-section col-md-12'>
          <div className='workbench-top-section-item col-md-6'>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: this.changeFlexDirection,
                gap: 10,
              }}
            >
              <div style={{ width: '100%', flexGrow: 1 }}>
                <label>Supervisor</label>
                <DropDownListComponent
                  id='supervisorWorkbench'
                  placeholder='SuperVisor'
                  dataSource={this.state.SupervisorData}
                  ref={(scope: DropDownListComponent) =>
                    (this.ddSuppervisor = scope)
                  }
                  fields={this.fieldSupervisor}
                />
              </div>
              <div style={{ width: '100%', flexGrow: 1 }}>
                <label>Site</label>
                <DropDownListComponent
                  placeholder='Sites'
                  dataSource={this.state.SiteData}
                  fields={this.fieldSites}
                  ref={(scope: DropDownListComponent) => (this.ddSites = scope)}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: this.changeFlexDirection,
                gap: 10,
              }}
            >
              <div style={{ width: '100%', flexGrow: 1 }}>
                <label>Location</label>
                <DropDownListComponent
                  placeholder='Location'
                  dataSource={this.state.LocationData}
                  fields={this.fieldLocation}
                  ref={(scope: DropDownListComponent) =>
                    (this.ddLocation = scope)
                  }
                />
              </div>
              <div style={{ width: '100%', flexGrow: 1 }}>
                <label>Status</label>
                <DropDownListComponent
                  placeholder='Status'
                  dataSource={this.state.WorkbencStatusData}
                  fields={this.fieldWorkbenchStatus}
                  itemTemplate={this.itemTemplateWorkbenchStatusColor.bind(
                    this
                  )}
                  //  valueTemplate={this.statusValueTemplate = this.statusValueTemplate.bind(this)}
                  ref={(scope) => (this.ddWorkbenchStatusData = scope)}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <div style={{ width: '100%', flexGrow: 2 }}>
                <label>Shift</label>
                <DropDownListComponent
                  placeholder='Shift'
                  dataSource={this.state.ElementAliasData}
                  fields={this.fieldAlias}
                  ref={(scope: DropDownListComponent) => (this.ddShift = scope)}
                />
              </div>
              <div
                style={{ width: '100%', flexGrow: 2 }}
                className='disabledTeam'
              >
                <label>Teams</label>
                <DropDownListComponent
                  placeholder='Teams'
                  dataSource={this.state.TeamsData}
                  fields={this.fieldTeams}
                  ref={(scope) => (this.ddTeams = scope)}
                  onChange={this.onChangeTeams.bind(this)}
                />
              </div>
              <div
                style={{
                  width: '50%',
                  display: 'flex',
                  flexGrow: 1,
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  textAlign: 'right',
                }}
              >
                <label>Show All Assignments</label>
                <SwitchComponent
                  checked={this.state.checkedAllAssignment}
                  onChange={this.onChangeShowAllAssignment.bind(this)}
                />
              </div>
            </div>
          </div>
          <div className='workbench-top-section-item col-md-5'>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              <div className='disabledWorkbencDate workbench-flex'>
                <label>Transaction Date</label>
                <DatePickerComponent
                  format={this.formatOptions}
                  value={this.created_date}
                  placeholder='Transaction Date'
                  onChange={this.OnChangeTransactionDate.bind(this)}
                />
              </div>
              {this.props.workbench_id !== -1 ? (
                <div className='disabledWorkbencDate' style={{ width: '50%' }}>
                  <label>Workbench ID</label>
                  <div className='workbench-id'>{this.props.workbench_id}</div>
                </div>
              ) : null}
            </div>

            <div className='disabledWorkbencDate'>
              <label>Day</label>
              <ChipListComponent
                id='chip-avatar-workbench-day'
                selection='Single'
                ref={(g: ChipListComponent) => (this.chipWorkbenchDay = g)}
                onClick={this.selectedChipDayt.bind(this)}
              >
                <ChipsDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Monday'
                  ></ChipDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Tuesday'
                  ></ChipDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Wednesday'
                  ></ChipDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Thursday'
                  ></ChipDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Friday'
                  ></ChipDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Saturday'
                  ></ChipDirective>
                  <ChipDirective
                    cssClass='chip-style-workbench'
                    text='Sunday'
                  ></ChipDirective>
                </ChipsDirective>
              </ChipListComponent>
            </div>
          </div>
          <div className='workbench-top-section-item col-md-1'>
            <button
              className='btn btn-primary h-50 fs-5'
              onClick={this.savePoint.bind(this)}
            >
              Save
            </button>
            <button
              className='btn btn-secondary h-50 fs-5'
              onClick={this.clearForInput.bind(this)}
            >
              New
            </button>
            <button
              className='btn btn-secondary h-20'
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>
                {!this.state.showSection1 ? (
                  <AiOutlineEye
                    size={20}
                    onClick={() => {
                      this.setState({ showSection1: !this.state.showSection1 });
                    }}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    size={20}
                    onClick={() => {
                      this.setState({ showSection1: !this.state.showSection1 });
                    }}
                  />
                )}
              </span>
              <span>
                {!this.state.showSection2 ? (
                  <AiOutlineEye
                    size={20}
                    onClick={() => {
                      if (this.props.workbench_id === -1) {
                        Message.error('There is no selected Workbench Item');
                        return;
                      }
                      this.setState({ showSection2: !this.state.showSection2 });
                    }}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    size={20}
                    onClick={() => {
                      if (this.props.workbench_id === -1) {
                        Message.error('There is no selected Workbench Item');
                        return;
                      }
                      this.setState({ showSection2: !this.state.showSection2 });
                    }}
                  />
                )}
              </span>
            </button>
          </div>
        </div>
        {!this.state.showSection1 ? (
          <div className='workbench-middle-top-section col-md-12'>
            <div className='workbench-middle-section col-md-12'>
              <div className='workbench-middle-section-item col-md-3'>
                <div className='workbench-title'>
                  <label>Incidents</label>
                </div>
                <GridComponent
                  id='gridWorkbenchIncidents'
                  dataSource={this.state.WorkbenchIncidentsData}
                  editSettings={this.editOptions}
                  toolbar={this.toolbarOptions}
                  ref={(g) => (this.gridWorkbenchIncidentsObj = g)}
                  filterSettings={this.FilterOptions}
                  allowFiltering={true}
                  allowExcelExport={true}
                  allowPaging={false}
                  pageSettings={this.pageOptions}
                  toolbarClick={this.toolbarClickIncidents.bind(this)}
                  showColumnMenu={true}
                  allowResizing={true}
                  allowGrouping={true}
                  style={{ display: 'inline-block' }}
                  gridLines='Both'
                  enablePersistence
                  height='20vh'
                  showColumnChooser
                  actionBegin={this.actionBeginIncidents.bind(this)}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field='id'
                      headerText='ID'
                      width='100'
                      textAlign='Left'
                      visible={false}
                      isPrimaryKey={true}
                    />
                    <ColumnDirective
                      field='incidents'
                      headerText='Name'
                      editType='dropdownedit'
                      editTemplate={this.OperatorTemplateEditing.bind(this)}
                    />
                    <ColumnDirective
                      field='incidents_type'
                      headerText='Incident Type'
                      editType='dropdownedit'
                      editTemplate={this.IncidentsTypeTemplateEditing.bind(
                        this
                      )}
                    />
                    <ColumnDirective
                      field='incidents_date'
                      validationRules={this.validationRule}
                      headerText='Incident Date'
                      editType='datetimepickeredit'
                      format='dd/MM/yyyy'
                    />
                    <ColumnDirective
                      field='days_into_roster'
                      validationRules={this.validationRule}
                      headerText='Days Into Roster'
                    />
                    <ColumnDirective
                      field='comments'
                      validationRules={this.validationRule}
                      headerText='Comments'
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Edit,
                      Toolbar,
                      Filter,
                      ColumnChooser,
                      ExcelExport,
                      Page,
                      ColumnMenu,
                      Resize,
                      Group,
                    ]}
                  />{' '}
                </GridComponent>
              </div>
              <div className='workbench-middle-section-item col-md-3'>
                <div className='workbench-title'>
                  {' '}
                  <label>HSEQ</label>
                </div>

                <GridComponent
                  id='gridWorkenchHse'
                  dataSource={this.state.WorkbenchHseData}
                  editSettings={this.editOptions}
                  toolbar={this.toolbarOptions}
                  ref={(g) => (this.gridWorkbenchHseObj = g)}
                  filterSettings={this.FilterOptions}
                  allowFiltering={true}
                  allowPaging={false}
                  pageSettings={this.pageOptions}
                  toolbarClick={this.toolbarClickHse.bind(this)}
                  showColumnMenu={true}
                  allowResizing={true}
                  allowGrouping={true}
                  style={{ display: 'inline-block' }}
                  gridLines='Both'
                  height='20vh'
                  //  enablePersistence
                  allowExcelExport={true}
                  showColumnChooser
                  actionBegin={this.actionBeginHse.bind(this)}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field='id'
                      headerText='ID'
                      width='100'
                      textAlign='Left'
                      visible={false}
                      isPrimaryKey={true}
                    />
                    <ColumnDirective
                      field='hse_code'
                      headerText='Code'
                      editType='dropdownedit'
                      editTemplate={this.HseDetailsTemplateEditing.bind(this)}
                    />
                    <ColumnDirective
                      field='description'
                      validationRules={this.validationRule}
                      headerText='Notes'
                    />
                    <ColumnDirective
                      field='isChecked'
                      template={this.isHseStatustemplate.bind(this)}
                      editTemplate={this.isHseStatustemplateEditing.bind(this)}
                      headerText='Status'
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Edit,
                      Toolbar,
                      Filter,
                      ColumnChooser,
                      ExcelExport,
                      Page,
                      ColumnMenu,
                      Resize,
                      Group,
                    ]}
                  />{' '}
                </GridComponent>
              </div>
              <div className='workbench-middle-section-item col-md-6'>
                <div className='workbench-title'>
                  {' '}
                  <label>Hazards & Actions</label>
                </div>

                <GridComponent
                  id='gridWorkenchHazarActions'
                  dataSource={this.state.WorkbenchHazardData}
                  editSettings={this.editOptions}
                  toolbar={this.toolbarOptions}
                  ref={(g) => (this.gridWorkenchHazarActionsObj = g)}
                  filterSettings={this.FilterOptions}
                  allowFiltering={true}
                  allowPaging={false}
                  pageSettings={this.pageOptions}
                  toolbarClick={this.toolbarClickHazard.bind(this)}
                  showColumnMenu={true}
                  allowResizing={true}
                  allowGrouping={true}
                  style={{ display: 'inline-block' }}
                  gridLines='Both'
                  height='20vh'
                  // enablePersistence
                  showColumnChooser
                  allowExcelExport={true}
                  actionBegin={this.actionBeginHazard.bind(this)}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field='id'
                      headerText='ID'
                      width='100'
                      textAlign='Left'
                      isPrimaryKey={true}
                      visible={false}
                    />
                    <ColumnDirective
                      field='hazard'
                      headerText='Hazard'
                      validationRules={this.validationRule}
                      textAlign='Left'
                    />
                    <ColumnDirective
                      field='actions'
                      validationRules={this.validationRule}
                      headerText='Action'
                    />
                    <ColumnDirective
                      field='raised_by'
                      headerText='Raised By'
                      editType='dropdownedit'
                      editTemplate={this.OperatorRaisedByTemplateEditing.bind(
                        this
                      )}
                    />
                    <ColumnDirective
                      field='action_by'
                      headerText='Action By'
                      editType='dropdownedit'
                      editTemplate={this.OperatorActionByTemplateEditing.bind(
                        this
                      )}
                    />
                    <ColumnDirective
                      field='action_date'
                      validationRules={this.validationRule}
                      headerText='Action Date'
                      editType='datetimepickeredit'
                    />
                    <ColumnDirective
                      field='completed'
                      headerText='Completed'
                      template={this.isCompleteTemplate.bind(this)}
                      editTemplate={this.isCompleteTemplateEditin.bind(this)}
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Edit,
                      Toolbar,
                      Filter,
                      ColumnChooser,
                      ExcelExport,
                      Page,
                      ColumnMenu,
                      Resize,
                      Group,
                    ]}
                  />{' '}
                </GridComponent>
              </div>
            </div>
            <div className='workbench-middle-section col-md-12'>
              <div className='workbench-middle-section-item col-md-3'>
                <div className='workbench-title'>
                  {' '}
                  <label>Leave Absentees</label>
                </div>

                <GridComponent
                  id='gridWorkbenchLeaveAbsentees'
                  dataSource={this.state.WorkbenchLeaveData}
                  editSettings={this.editOptions}
                  toolbar={this.toolbarOptions}
                  ref={(g) => (this.gridWorkbenchLeaveAbsenteesObj = g)}
                  filterSettings={this.FilterOptions}
                  allowFiltering={true}
                  allowPaging={false}
                  pageSettings={this.pageOptions}
                  toolbarClick={this.toolbarClickLeave.bind(this)}
                  showColumnMenu={true}
                  allowResizing={true}
                  allowGrouping={true}
                  style={{ display: 'inline-block' }}
                  gridLines='Both'
                  height='20vh'
                  //   enablePersistence
                  allowExcelExport={true}
                  showColumnChooser
                  actionBegin={this.actionBeginLeave.bind(this)}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field='id'
                      headerText='ID'
                      width='100'
                      textAlign='Left'
                      isPrimaryKey={true}
                      visible={false}
                    />
                    <ColumnDirective
                      field='name'
                      headerText='Name'
                      editType='dropdownedit'
                      editTemplate={this.OperatorLeaveTemplateEditing.bind(
                        this
                      )}
                    />
                    <ColumnDirective
                      field='leave_type'
                      headerText='Leave Type'
                      editType='dropdownedit'
                      editTemplate={this.LeaveAbsentesTypeTemplateEditing.bind(
                        this
                      )}
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Edit,
                      Toolbar,
                      Filter,
                      ColumnChooser,
                      ExcelExport,
                      Page,
                      ColumnMenu,
                      Resize,
                      Group,
                    ]}
                  />{' '}
                </GridComponent>
              </div>
              <div className='workbench-middle-section-item col-md-3'>
                <div className='workbench-title'>
                  {' '}
                  <label>Notes and Event Comments</label>
                </div>
                <div
                  className='workbench-notes'
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <div>
                    <TextBoxComponent
                      multiline
                      value={this.issue}
                      created={this.onCreateIssue.bind(this)}
                      ref={(scope) => {
                        this.textareaObjIssue = scope;
                      }}
                      onChange={(e: any) => {
                        this.issue = e.target.value;
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className='workbench-middle-section-item col-md-6'>
                <div className='workbench-title'>
                  <label>Equipment Downtime</label>
                </div>
                <GridComponent
                  id='gridWorkbenchEquipmentDowntime'
                  dataSource={this.state.WorkbenchEquipmentData}
                  editSettings={this.editOptions}
                  toolbar={this.toolbarOptions}
                  ref={(g) => (this.gridWorkbenchEquipmentDowntimeObj = g)}
                  filterSettings={this.FilterOptions}
                  allowFiltering={true}
                  allowPaging={false}
                  pageSettings={this.pageOptions}
                  toolbarClick={this.toolbarClickEquipmentDowntime.bind(this)}
                  showColumnMenu={true}
                  allowResizing={true}
                  enablePersistence
                  allowGrouping={true}
                  style={{ display: 'inline-block' }}
                  gridLines='Both'
                  height='20vh'
                  allowExcelExport={true}
                  showColumnChooser
                  actionBegin={this.actionBeginEquipment.bind(this)}
                  dataBound={() => {
                    var searchEle =
                      this.gridWorkbenchEquipmentDowntimeObj.element.querySelector(
                        '#' +
                          this.gridWorkbenchEquipmentDowntimeObj.element.id +
                          '_searchbar'
                      );
                    if (searchEle) {
                      searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
                    }
                  }}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field='id'
                      headerText='ID'
                      textAlign='Left'
                      isPrimaryKey={true}
                      visible={false}
                    />
                    <ColumnDirective
                      field='assets_description'
                      validationRules={this.validationRule}
                      headerText='Asset Description'
                    />
                    <ColumnDirective
                      field='start_time'
                      validationRules={this.validationRule}
                      headerText='Start'
                      editType='datetimepickeredit'
                      format='dd/MM/yyyy'
                      type='date'
                    />
                    <ColumnDirective
                      field='end_time'
                      validationRules={this.validationRule}
                      headerText='End'
                      editType='datetimepickeredit'
                      format='dd/MM/yyyy'
                      type='date'
                    />
                    <ColumnDirective
                      field='duration'
                      validationRules={this.validationRule}
                      headerText='Duration'
                    />
                    <ColumnDirective
                      field='machine_impacted'
                      validationRules={this.validationRule}
                      headerText='Machine Impacted'
                    />
                    <ColumnDirective
                      field='reason_for_delay'
                      validationRules={this.validationRule}
                      headerText='Reason For Delay'
                    />
                    <ColumnDirective
                      field='reason_code'
                      headerText='Reason Code'
                      editTemplate={this.EquipmentDowntimeReasonTemplateEditing.bind(
                        this
                      )}
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Edit,
                      Toolbar,
                      Filter,
                      ColumnChooser,
                      ExcelExport,
                      Page,
                      ColumnMenu,
                      Resize,
                      Group,
                    ]}
                  />{' '}
                </GridComponent>
              </div>
            </div>
          </div>
        ) : null}

        {!this.state.showSection2 ? (
          <div className='final-section col-md-12'>
            <TabWorkbench workbench_data={this.props.workbench_data} />
          </div>
        ) : null}
      </div>
    );
  }
}
export default ShiftWorkbench;
